import { render } from "./PatchConfirmPopup.vue?vue&type=template&id=36d8cbee&scoped=true"
import script from "./PatchConfirmPopup.vue?vue&type=script&lang=js"
export * from "./PatchConfirmPopup.vue?vue&type=script&lang=js"

import "./PatchConfirmPopup.vue?vue&type=style&index=0&id=36d8cbee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d8cbee"]])

export default __exports__